import React from "react";
import { BaseBox } from "../exports"; 


const BasePre = ({ children, sx = {}, ...props }) => {
  return (
    <BaseBox
      component="pre"
      sx={{
        fontFamily: "monospace",
        fontSize: "0.875rem",
        backgroundColor: "#f7f7f7",
        color: "#333",
        padding: 2,
        borderRadius: 2,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        overflow: "auto",
        ...sx,
      }}
      {...props}
    >
      {children}
    </BaseBox>
  );
};

export default BasePre;
